<template>
  <calendesk-ai-assistant
    v-if="isVisible"
    :api-url="apiUrl"
    token-source="localStorage"
    token-key="accessToken"
    theme="light"
    @click="onWidgetClick"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { refreshToken } from "@/lib/calendesk-js-library/api/api-client";
import { tokenOperations } from "@/lib/calendesk-js-library/tools/token";
import { pushEvent } from "@/lib/calendesk-js-library/tools/helpers";
import { syncChatLaunchers } from "@/lib/calendesk-js-library/tools/chatLaunchers";

export default {
  name: "AiAssistant",
  data() {
    return {
      interactionTracked: false,
    };
  },
  computed: {
    ...mapGetters({
      isUserLogged: "auth/isUserLogged",
    }),
    apiUrl() {
      return process.env.VUE_APP_AI_GATEWAY_URL || null;
    },
    isVisible() {
      return (
        this.isUserLogged &&
        !!this.apiUrl &&
        !!this.$config("ai_chat_widget_enabled")
      );
    },
  },
  mounted() {
    this._handleTokenRefresh = (event) => {
      refreshToken()
        .then((response) => {
          tokenOperations(response.data);
          event.detail.callback(response.data.access_token);
        })
        .catch(() => {
          event.detail.callback(null);
        });
    };
    document.addEventListener(
      "calendesk-auth-refresh-needed",
      this._handleTokenRefresh,
    );
  },
  beforeDestroy() {
    document.removeEventListener(
      "calendesk-auth-refresh-needed",
      this._handleTokenRefresh,
    );
  },
  methods: {
    // Opening or closing the assistant changes only its shadow DOM, which the launcher watch
    // does not see.
    onWidgetClick() {
      syncChatLaunchers();
      this.trackInteraction();
    },
    // The widget handles open/close inside its shadow DOM and emits no
    // events for them; the first composed click is the closest reliable
    // "user engaged with the assistant" signal.
    trackInteraction() {
      if (!this.interactionTracked) {
        this.interactionTracked = true;
        pushEvent("aiAssistantOpened");
      }
    },
  },
};
</script>
